import { render, staticRenderFns } from "./PlayerDeleteModal.vue?vue&type=template&id=12225ed7&"
import script from "./PlayerDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./PlayerDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports